import { DefaultOptionType } from 'antd/es/select';
import React, { CSSProperties } from 'react';
import styles from 'src/app/components/OptionTagsComponent/OptionTags.module.scss';
import { useAppSelector } from 'src/app/redux/hook';
import { PureCancelIcon } from 'src/icons';

interface IOptionTagsProps {
  options: DefaultOptionType[];
  onDelete?: (filteredOptions: DefaultOptionType[], deleted: DefaultOptionType) => void;
  tagStyle?: CSSProperties;
  text?: 'OR' | 'AND';
  rootStyle?: CSSProperties;
}

const tagCloseIconStyle: React.CSSProperties = {
  width: '14.75px',
  height: '14.75px',
  marginLeft: '8px',
};

// This component is used to show tags from given options
const OptionTags: React.FC<IOptionTagsProps> = ({ options, onDelete, tagStyle, text, rootStyle }) => {
  const { theme } = useAppSelector((state) => state.configContent);

  const onTagDelete = (
    source: DefaultOptionType,
    deleteFn: (filteredOptions: DefaultOptionType[], deleted: DefaultOptionType) => void,
  ) => {
    const filteredOptions = options.filter((obj) => obj.value !== source.value);
    deleteFn(filteredOptions, source);
  };

  return (
    <div className={styles.tagsContainer} style={rootStyle}>
      {options?.map((source, idx) => (
        <div key={source.value} style={{ display: 'flex' }}>
          <div style={tagStyle || { backgroundColor: theme.colors.quoteBgc }} className={styles.tag}>
            {source.label}
            {onDelete && <PureCancelIcon style={tagCloseIconStyle} onClick={() => onTagDelete(source, onDelete)} />}
          </div>
          {idx + 1 < options.length && text && <div className={styles.or}>{text}</div>}
        </div>
      ))}
    </div>
  );
};

export default OptionTags;
